// File Metadata:
// Filename: downloadUtils.js
// Version: 1.00
// Created: 2025-03-23 20:35:55
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

export const downloadImage = async (url, filename) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
    } catch (err) {
        console.error('Failed to download image:', err);
    }
};

export const downloadAllImages = async (photos) => {
    const zip = require('jszip')();
    const zipName = 'quality-photos.zip';

    try {
        // Create a folder in the zip
        const folder = zip.folder('quality-photos');
        
        // Download all images and add to zip
        await Promise.all(photos.map(async (photo, index) => {
            const response = await fetch(photo.imageUrl);
            const blob = await response.blob();
            const filename = `photo-${photo.fileId}.jpg`;
            folder.file(filename, blob);
        }));

        // Generate and download zip
        const content = await zip.generateAsync({ type: 'blob' });
        const zipUrl = URL.createObjectURL(content);
        
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = zipName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(zipUrl);
    } catch (err) {
        console.error('Failed to download images:', err);
    }
};

export const downloadAllShipmentImages = async (photos) => {
    const zip = require('jszip')();
    const zipName = 'shipment-photos.zip';

    try {
        // Create a folder in the zip
        const folder = zip.folder('shipment-photos');
        
        // Download all images and add to zip
        await Promise.all(photos.map(async (photo, index) => {
            const response = await fetch(photo.url);
            const blob = await response.blob();
            const filename = `photo-${photo.fileId}.jpg`;
            folder.file(filename, blob);
        }));

        // Generate and download zip
        const content = await zip.generateAsync({ type: 'blob' });
        const zipUrl = URL.createObjectURL(content);
        
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = zipName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(zipUrl);
    } catch (err) {
        console.error('Failed to download images:', err);
    }
};
